/*
  Pilotfish — the product card's variant picker.

  The card renders the same picker the product page does: one fieldset per
  option, the theme's own `.color-swatch` / `.label-swatch` radios inside it.
  This script is what makes those radios mean something in a grid, where there
  is no `product-info` element and no section to re-render.

  On every change it:
    1. reads the checked value of each option,
    2. resolves that combination against the card's `data-pf-variant-data`
       (id, options, available, image — emitted by snippets/product-card.liquid),
    3. writes the id into the add-to-cart form, swaps the card image, and
       updates the "COLOR: The Original" value shown next to the option name.

  Resolving client-side is deliberate: a collection page can hold a dozen of
  these, and a fetch per swatch click would make the grid feel slow.

  If a combination has no variant, or has one that is sold out, the button is
  disabled rather than hidden — a card that silently loses its add-to-cart
  reads as broken. The old "Choose options" link stays in the markup for cards
  that render WITHOUT a picker (swatches turned off in theme settings); with a
  picker present every option is chosen here, so it never shows.
*/
(function () {
  'use strict';

  function variantData(card) {
    var node = card.querySelector('[data-pf-variant-data]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  // Checked value of each option, in option order — the shape of `variant.options`.
  function selection(card) {
    var groups = card.querySelectorAll('[data-pf-option-index]');
    var values = [];
    groups.forEach(function (group) {
      var checked = group.querySelector('input:checked');
      values.push(checked ? checked.value : null);
    });
    return values;
  }

  function matchVariant(variants, values) {
    if (!variants) return null;
    for (var i = 0; i < variants.length; i++) {
      var opts = variants[i].options || [];
      var hit = true;
      for (var j = 0; j < values.length; j++) {
        if (opts[j] !== values[j]) { hit = false; break; }
      }
      if (hit) return variants[i];
    }
    return null;
  }

  function setImage(card, src) {
    if (!src) return;
    var media = card.querySelector('.product-card__media img');
    if (!media) return;
    media.setAttribute('src', src);
    // The theme ships responsive srcsets; clear it or the browser keeps
    // choosing from the OLD candidate list and the swap appears to do nothing
    // on wide screens.
    media.removeAttribute('srcset');
    media.removeAttribute('data-srcset');
  }

  function sync(card, variants, swapImage) {
    var values = selection(card);

    // "COLOR: The Original" — the label follows the radios.
    card.querySelectorAll('[data-pf-option-index]').forEach(function (group, i) {
      var label = group.querySelector('[data-pf-option-value]');
      if (label && values[i]) label.textContent = values[i];
    });

    var variant = matchVariant(variants, values);
    var actions = card.querySelector('[data-pf-card-actions]');
    if (!actions) return;

    var input = actions.querySelector('[data-pf-variant-input]');
    var addBtn = actions.querySelector('[data-pf-add]');

    if (input && variant) input.value = variant.id;
    if (swapImage && variant) setImage(card, variant.image);

    if (addBtn) {
      var sellable = !!(variant && variant.available);
      addBtn.disabled = !sellable;
      if (sellable) {
        addBtn.textContent = addBtn.dataset.pfLabel || addBtn.textContent;
      } else {
        addBtn.textContent = variant ? 'Sold out' : 'Unavailable';
      }
    }
  }

  function initCard(card) {
    var picker = card.querySelector('[data-pf-options]');
    if (!picker) return;

    var variants = variantData(card);
    var addBtn = card.querySelector('[data-pf-add]');
    if (addBtn && !addBtn.dataset.pfLabel) {
      addBtn.dataset.pfLabel = addBtn.textContent.trim();
    }

    picker.addEventListener('change', function (event) {
      if (!event.target.matches('input[type="radio"]')) return;
      sync(card, variants, true);
    });

    // Reflect what the card was rendered with, without touching the image:
    // the server already chose it, and re-setting it would drop the srcset
    // for no gain.
    sync(card, variants, false);
  }

  function init(root) {
    (root || document).querySelectorAll('.product-card').forEach(function (card) {
      if (card.dataset.pfCardInit) return;
      card.dataset.pfCardInit = '1';
      initCard(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Collection filtering and pagination replace the grid in place.
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      if (records[i].addedNodes.length) { init(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
